<template>
  <ModalWrapper :modalName="modalName" maxWidth="max-w-2xl">
    <div class="w-full pb-5">
      <p
        class="mb-4 text-center text-22 font-medium text-primary-100 lg:text-left lg:text-2xl"
      >
        {{ $t("account.doctor_consent_title") }}
      </p>
    </div>

    <transition-group name="list">
      <div
        class="flex flex-col items-start md:pb-7"
        v-for="doctor in doctors"
        :key="doctor.id"
      >
        <div class="text-body-8-d text-gray">
          {{ $t("account.doctor_short") }}
          <span class="font-normal"
            >{{ doctor.first_name }} {{ doctor.last_name }}</span
          >
          {{ $t("account.doctor_consent_content") }}
        </div>

        <div
          class="mt-4 flex w-full items-center justify-end space-x-8 text-sm md:justify-end"
        >
          <Button
            type="button"
            theme="link"
            class="relative px-4 py-2"
            @click="onClickReject(doctor.id)"
            :disabled="isLoading"
          >
            {{ $t("action.reject") }}
          </Button>

          <Button
            type="button"
            theme="secondary"
            class="relative w-40 px-4 py-2"
            @click="onClickConfirm(doctor.id)"
            :disabled="isLoading"
          >
            {{ $t("action.accept") }}
          </Button>
        </div>
      </div>
    </transition-group>
  </ModalWrapper>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import isMobile from "@/mixins/isMobile";
import ModalWrapper from "@/components/Core/ModalWrapper.vue";
import Button from "@/components/Core/ButtonBase.vue";

export default {
  name: "PatientModalDoctorAskForAccessToHistoryModal",
  components: {
    ModalWrapper,
    Button,
  },
  data() {
    return {
      isLoading: false,
      modalName: "doctorAskForAccessToHistoryModal",
    };
  },
  mixins: [isMobile],
  computed: {
    ...mapGetters({
      doctors: "user/doctorsAskedForAccess",
    }),
  },
  methods: {
    onClickConfirm(id) {
      this.sendAddAccessForHistory(id, true);
    },
    onClickReject(id) {
      this.sendAddAccessForHistory(id, false);
    },
    async sendAddAccessForHistory(id, addAccess) {
      this.isLoading = true;
      await this.shareExaminationsForDoctor({
        id,
        addAccess,
      });

      if (this.doctors.length === 0) {
        this.closeModal(this.modalName);
      }

      this.isLoading = false;
    },
    ...mapMutations({
      closeModal: "modals/closeModal",
    }),
    ...mapActions({
      shareExaminationsForDoctor: "user/shareExaminationsForDoctor",
    }),
  },
};
</script>
